import React, { useState } from "react";
import { getImageUrl } from "../../utils/Helper";
import GalleryModal from "../Common/Modal/GalleryModal";
const ImageGallery = (props) => {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  let AllImgData = props.filesData[0];
  if (props.filesData && props.filesData[1] && props.filesData[1].length > 0) {
    AllImgData = [...AllImgData, ...props.filesData[1]];
  }

  if (props.variant === "event-details") {
    return (
      <section className="event-details-block" aria-label="Event gallery">
        <div className="event-details-block-head">
          <h2 className="event-details-block-title">{props.title}</h2>
          <p className="event-details-block-sub">
            Tap a photo to open the gallery viewer.
          </p>
        </div>
        <div className="event-details-gallery">
          {AllImgData.map((image, index) => (
            <button
              key={index}
              type="button"
              className="event-details-gallery-item"
              aria-label={`Open gallery image ${index + 1}`}
              onClick={() => {
                setIsOpen(true);
                setPhotoIndex(index);
              }}
            >
              <img
                src={image.preview ? image.preview : getImageUrl(image.path)}
                alt=""
                onLoad={() => {
                  if (image.preview) {
                    URL.revokeObjectURL(image.preview);
                  }
                }}
              />
            </button>
          ))}
        </div>
        <GalleryModal
          filesData={AllImgData}
          Open={isOpen}
          Index={photoIndex}
          onClose={() => setIsOpen(false)}
        />
      </section>
    );
  }

  return (
    <>
      <div className="usrEvntGallery">
        <h4>{props.title}</h4>
        <div className="row gallery-row d-flex ">
          {AllImgData.map((image, index) => {
            return (
              <div className="col-md-3" key={index}>
                <div className="closeIcon">
                  <img
                    style={{ width: "150px", height: "120px" }}
                    src={
                      image.preview ? image.preview : getImageUrl(image.path)
                    }
                    onLoad={() => {
                      if (image.preview) {
                        URL.revokeObjectURL(image.preview);
                      }
                    }}
                    onClick={() => {
                      setIsOpen(true);
                      setPhotoIndex(index);
                    }}
                  />
                  {props.removeHandler && (
                    <button
                      type="button"
                      className="close-btn"
                      onClick={() => props.removeHandler(image, props.eventId)}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
              </div>
            );
          })}
          <GalleryModal
            filesData={AllImgData}
            Open={isOpen}
            Index={photoIndex}
            onClose={() => setIsOpen(false)}
          />
        </div>
      </div>
    </>
  );
};
export default ImageGallery;
